/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createBaseClientRepresentationFromDiscriminatorValue, serializeBaseClientRepresentation } from '../../../../../models/index.js';
// @ts-ignore
import { V2ItemRequestBuilderRequestsMetadata } from './item/index.js';
/**
 * Uri template for the request builder.
 */
export const V2RequestBuilderUriTemplate = "{+baseurl}/admin/api/{realmName}/clients/v2{?fields,limit*,offset*,q*,sort*}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const V2RequestBuilderNavigationMetadata = {
    byId: {
        requestsMetadata: V2ItemRequestBuilderRequestsMetadata,
        pathParametersMappings: ["id"],
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const V2RequestBuilderRequestsMetadata = {
    get: {
        uriTemplate: V2RequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        adapterMethodName: "sendCollection",
        responseBodyFactory: createBaseClientRepresentationFromDiscriminatorValue,
    },
    post: {
        uriTemplate: V2RequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        adapterMethodName: "send",
        responseBodyFactory: createBaseClientRepresentationFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeBaseClientRepresentation,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=index.js.map